import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useRealtime } from "@/lib/realtime";

export const changeRequestsApi = {
  count: () => api.get("/change-requests/count").then((r) => r.data.pending || 0),
  list: (status) => api.get("/change-requests", { params: { status } }).then((r) => r.data),
  approve: (id) => api.post(`/change-requests/${id}/approve`).then((r) => r.data),
  reject: (id) => api.post(`/change-requests/${id}/reject`, {}).then((r) => r.data),
};

export const STATUS_TONE = {
  pending: "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300",
  executed: "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300",
  rejected: "bg-zinc-200 text-zinc-700 dark:bg-zinc-500/20 dark:text-zinc-300",
  expired: "bg-zinc-200 text-zinc-600 dark:bg-zinc-500/20 dark:text-zinc-400",
  error: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
  needs_review: "bg-orange-100 text-orange-800 dark:bg-orange-500/15 dark:text-orange-300",
};

// Numero di richieste in attesa (solo Super Admin): realtime + controllo ogni 60s.
export function usePendingChanges(enabled) {
  const [n, setN] = useState(0);
  const load = useCallback(() => { if (enabled) changeRequestsApi.count().then(setN).catch(() => {}); }, [enabled]);
  useEffect(() => {
    load();
    if (!enabled) return undefined;
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, [enabled, load]);
  useRealtime("change_requests", load);
  return n;
}
